/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ShareContentResult = zod.object({
  email: zod.string().optional(),
  expiresAt: zod.string().nullable(),
  lineageUuid: zod.uuid().describe('UUID v4 identifier'),
  outcome: zod
    .enum(['granted', 'changed', 'revoked', 'unchanged'])
    .describe(
      'granted: new access. changed: the permissions or expiry moved. revoked: access removed. unchanged: nothing to do (the same grant, or a revocation with nothing to revoke).',
    ),
  permissions: zod
    .array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']))
    .describe('What the audience holds on the lineage now; empty once revoked.'),
  principalType: zod
    .enum(['USER', 'GROUP', 'GROUP_MEMBERS', 'PUBLIC'])
    .describe(
      'Who the grant is for: one person (USER), a group acting as itself (GROUP), everyone in a group (GROUP_MEMBERS), or everyone (PUBLIC).',
    ),
  principalUuid: zod.uuid().describe('For an email recipient, the account it resolved to.'),
  userCreated: zod.boolean().optional().describe('An email recipient got a new account.'),
});

export type ShareContentResult = zod.input<typeof ShareContentResult>;
export type ShareContentResultOutput = zod.output<typeof ShareContentResult>;
